import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import $R from './relay.js';
dayjs.extend(utc)

// returns a promise for sensations
export function getSensations(params) {
  return $R.get("SecureSensation",params).then(rsp=>rsp.obj)
}

export function getUser(){
  return $R.get("SecureUser",{act:'current_user'}).then(rsp=>rsp.obj).catch(err=>console.log('must be logged in'))
}

export function getHomeForUser(user){
  return $R.get("SecureHouse",{id:user?.house_id}).then(rsp=>rsp.obj).catch(err=>console.log('must be logged in'))
}

/** if you already have a full house object, use the locations attribute */
export function getRooms(house){
  return $R.get("SecureItem",{dtf:{house_id:house.id,'type.name':'Location'}}).then(rsp=>rsp.obj)
}

export function getDevices(room){
  return $R.get("SecureItem",{dtf:{'groups':{group_id:room.id}}}).then(rsp=>rsp.obj)
}

export function getSensors(device){
  return $R.get("SecureItem",{dtf:{'groups':{group_id:device.id}}}).then(rsp=>rsp.obj)
}

/**
  Event:
    id, house_id, item_id, type_id, category_id, start_at, end_at, observed

  Categories: 'Sleep', 'Social', 'Hygiene', 'Food', 'Location'
  Types: 'Shower', 'In Bathroom', 'In Bedroom', 'Rest', 'At Location', 'Asleep', 'Awake',
    'Visitor', 'Fridge Open', 'Leave Home', 'Humidity Rising', 'Humidity Falling', 
    'Temperature Rising', 'Temperature Falling', 'Bright', 'Battery Low',
    'Storage Full', 'Restless Night', 'Stayed Home', 'Fewer Trips', 'Shorter Trips',
    'Longer Trips', 'More Trips', 'Silence', 'Less Active', 'Bedroom Dweller'
 */
/**
 * 
 * @param {*} annotation 
 * @returns 
 */
export function saveAnnotation(annotation){
  return $R.save("SecureEvent",annotation)
}